"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Usage;
exports.UpgradePrompt = UpgradePrompt;
exports.UpgradeToFreelancePrompt = UpgradeToFreelancePrompt;
exports.GetYourFreeDomainPrompt = GetYourFreeDomainPrompt;
exports.UpgradeTip = UpgradeTip;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _random = _interopRequireDefault(require("lodash/random"));

var _react = _interopRequireWildcard(require("react"));

var _filesize = _interopRequireDefault(require("filesize"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _tailwindConfig = require("../../../tailwind.config.js");

var _constants = require("../../../utils/constants");

var _reactI18next = require("react-i18next");

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var StylesLinearProgress = (0, _withStyles["default"])({
  colorPrimary: function colorPrimary(_ref) {
    var value = _ref.value;
    return {
      backgroundColor: _tailwindConfig.theme.colors.gray.divider
    };
  },
  barColorPrimary: function barColorPrimary(_ref2) {
    var value = _ref2.value;
    return {
      backgroundColor: value >= _constants.storageStatus.full ? _tailwindConfig.theme.colors.red : value >= _constants.storageStatus.warning ? _tailwindConfig.theme.colors.orange : _tailwindConfig.theme.colors.primary
    };
  }
})(_LinearProgress["default"]);

function Usage(_ref3) {
  var total = _ref3.total,
      usage = _ref3.usage,
      promptNode = _ref3.promptNode;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var value = Math.min(usage / total * 100, 100);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-6 py-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-gray-light"
  }, t('navigation.usage', {
    usage: (0, _filesize["default"])(usage),
    total: (0, _filesize["default"])(total)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: promptNode ? 'pt-2' : 'py-2'
  }, /*#__PURE__*/_react["default"].createElement(StylesLinearProgress, {
    value: value,
    variant: "determinate",
    color: "primary"
  })), promptNode && /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 leading-tight"
  }, promptNode));
}

function UpgradePrompt(_ref4) {
  var onUpgrade = _ref4.onUpgrade,
      upgradePlanName = _ref4.upgradePlanName;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary text-xs font-bold text-left",
    onClick: onUpgrade
  }, t('navigation.upgradePlan', {
    planName: upgradePlanName
  }));
}

function UpgradeToFreelancePrompt(_ref5) {
  var onUpgrade = _ref5.onUpgrade;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: 'navigation.upgradeToFreelance'
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "font-bold text-primary",
    onClick: onUpgrade
  })));
}

function GetYourFreeDomainPrompt(_ref6) {
  var onUpgrade = _ref6.onUpgrade;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: 'navigation.getYourFreeDomain'
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "font-bold text-primary",
    onClick: onUpgrade
  })));
}

var TRANSITION_TIMEOUT = 1000;

function UpgradeTip(_ref7) {
  var onClose = _ref7.onClose,
      onUpgrade = _ref7.onUpgrade,
      onTransitionEnd = _ref7.onTransitionEnd;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var handleHidden = function handleHidden() {
    setHidden(true);
    onClose && onClose();
    setTimeout(function () {
      return onTransitionEnd && onTransitionEnd();
    }, TRANSITION_TIMEOUT);
  };

  var children = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "rounded absolute shadow-md bg-secondary flex items-center justify-center",
      style: {
        left: '1rem',
        bottom: '1rem',
        right: '1rem',
        minHeight: 76,
        zIndex: '1000'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
      fontSize: "small",
      className: "text-gray-light cursor-pointer absolute right-0 top-0 mr-2 mt-2 hover:text-gray-dark",
      onClick: handleHidden
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center w-full px-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-shrink-0"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: t('custom-domain-new-email.png'),
      width: "60"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-grow text-xs text-left"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pr-6"
    }, t((0, _random["default"])(0, 1) ? 'navigation.upgradePrompt' : 'navigation.upgradePrompt1')), /*#__PURE__*/_react["default"].createElement("button", {
      className: "text-primary font-bold",
      onClick: onUpgrade
    }, t('button.upgrade')))));
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], {
    direction: "up",
    "in": !hidden,
    timeout: TRANSITION_TIMEOUT
  }, children);
}
//# sourceMappingURL=Usage.js.map